export default __webpack_public_path__ + "static/media/5.ff1357b2.webp";